import React, { useEffect, useState } from 'react';
import { style } from 'typestyle';
import CheckIcon from 'mdi-react/CheckCircleIcon';
import * as styles from './cards.styles';
import Column from '../../../core/components/column/column.component';
import { MainAxisAlignment, CrossAxisAlignment } from '../../../core/components/flex/flex.component';
import Row from '../../../core/components/row/row.component';
import type Office from '../../offices/models/office';

interface Props {
  readonly office: Office;
  readonly selectedOfficeChange: (officeSelected: Office) => void;
  readonly officesIdsSelected: string[] | [];
}

const OfficeForOfficeManagerListCard = ({ office, officesIdsSelected, selectedOfficeChange }: Props): React.JSX.Element => {
  const [isChecked, setIsChecked] = useState(false);
  const onClick = (): void => {
    selectedOfficeChange(office);
  };

  useEffect(() => {
    if (officesIdsSelected.some((officeSelected) => officeSelected === office.id)) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  }, [office, officesIdsSelected]);

  return (
    <div className={style(styles.dashboardSubCard(true))} key={office.name} onClick={onClick} role="presentation">
      <Row mainAxisAlignment={MainAxisAlignment.SpaceBetween} crossAxisAlignment={CrossAxisAlignment.Center}>
        <Column mainAxisAlignment={MainAxisAlignment.SpaceBetween}>
          <span className={style(styles.cardTitle)}>{office.name}</span>
        </Column>
        <CheckIcon className={style(styles.checkIcon(isChecked))} />
      </Row>
    </div>
  );
};

export default OfficeForOfficeManagerListCard;
